import React from "react";

import {convertToCountryLatLngLiteral} from "@pg-mono/open-street-map";

import {Country} from "../../../region/types/Country";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {createOfferLink} from "../../helpers/create_offer_link";
import {IOfferGroupsSimplified} from "../types/IOfferGroups";

export interface ISchemaOfferDetailOffer {
    description: string | null;
    id: number;
    geo_point: {
        coordinates: [number, number];
    };
    groups: IOfferGroupsSimplified | null;
    main_image_url?: string | null;
    name: string;
    slug: string;
    street_name: string | null;
    street_number: string | null;
    region: {
        country: Country;
        full_name: string;
    };
    vendor: {
        slug: string;
    };
}

interface IProps {
    offer: ISchemaOfferDetailOffer;
}

export const SchemaOfferDetail: React.FunctionComponent<IProps> = (props) => {
    const {offer} = props;

    const url = createOfferLink(offer);
    const {lng, lat} = convertToCountryLatLngLiteral(offer.geo_point.coordinates, offer.region.country);
    const address = `${offer.street_name} ${offer.street_number ? offer.street_number : ""}`;
    const json = {
        "@context": "http://schema.org/",
        "@type": "ApartmentComplex",
        name: offer.name,
        description: offer.description,
        url: url,
        address: {
            addressLocality: offer.region.full_name,
            streetAddress: address,
            addressCountry: {
                name: "PL"
            }
        },
        geo: {
            "@type": "GeoCoordinates",
            latitude: lat,
            longitude: lng
        },
        photo: getThumbnailLink(offer.main_image_url, 375, 211)
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
import React from "react";

import {convertToCountryLatLngLiteral} from "@pg-mono/open-street-map";

import {Country} from "../../../region/types/Country";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {createOfferLink} from "../../helpers/create_offer_link";
import {IOfferGroupsSimplified} from "../types/IOfferGroups";

export interface ISchemaOfferDetailOffer {
    description: string | null;
    id: number;
    geo_point: {
        coordinates: [number, number];
    };
    groups: IOfferGroupsSimplified | null;
    main_image_url?: string | null;
    name: string;
    slug: string;
    street_name: string | null;
    street_number: string | null;
    region: {
        country: Country;
        full_name: string;
    };
    vendor: {
        slug: string;
    };
}

interface IProps {
    offer: ISchemaOfferDetailOffer;
}

export const SchemaOfferDetail: React.FunctionComponent<IProps> = (props) => {
    const {offer} = props;

    const url = createOfferLink(offer);
    const {lng, lat} = convertToCountryLatLngLiteral(offer.geo_point.coordinates, offer.region.country);
    const address = `${offer.street_name} ${offer.street_number ? offer.street_number : ""}`;
    const json = {
        "@context": "http://schema.org/",
        "@type": "ApartmentComplex",
        name: offer.name,
        description: offer.description,
        url: url,
        address: {
            addressLocality: offer.region.full_name,
            streetAddress: address,
            addressCountry: {
                name: "PL"
            }
        },
        geo: {
            "@type": "GeoCoordinates",
            latitude: lat,
            longitude: lng
        },
        photo: getThumbnailLink(offer.main_image_url, 375, 211)
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
